export enum AttributeType {
  INLET_TEMPERATURE = 'inletTemperature',
  MODELS = 'model',
}
